export interface JobSiteMapLocation {
  lat?: number | string;
  lng?: number | string;
}

const DEFAULT_MAPBOX_TOKEN = "pk.eyJ1IjoiamxlZG5lciIsImEiOiJjbW40YXZ2ZjAxbHpxMnJuNWczcHE0NzFwIn0.QCOdHYxNHp9pW0kotfB1zQ";
const frontendEnv = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env;

const MAPBOX_MAX_LATITUDE = 85.0511;
const MAPBOX_ZOOM = 15;
const MAPBOX_BEARING = 0;
const MAPBOX_IMAGE_SIZE = "600x450@2x";

export function getMapboxToken(): string {
  return frontendEnv?.VITE_MAPBOX_TOKEN?.trim()
    || frontendEnv?.PUBLIC_MAPBOX_TOKEN?.trim()
    || DEFAULT_MAPBOX_TOKEN;
}

function parseCoordinate(value?: number | string): number | null {
  if (value === undefined || value === null) {
    return null;
  }

  if (typeof value === "string" && value.trim().length === 0) {
    return null;
  }

  const parsed = typeof value === "number" ? value : Number(value);

  if (!Number.isFinite(parsed)) {
    return null;
  }

  return parsed;
}

export function normalizeJobSiteLocation(
  location?: JobSiteMapLocation | null,
): { lat: number; lng: number } | null {
  if (!location) {
    return null;
  }

  const lat = parseCoordinate(location.lat);
  const lng = parseCoordinate(location.lng);

  if (lat === null || lng === null) {
    return null;
  }

  if (
    lat < -MAPBOX_MAX_LATITUDE
    || lat > MAPBOX_MAX_LATITUDE
    || lng < -180
    || lng > 180
  ) {
    return null;
  }

  return { lat, lng };
}

export function getJobSiteMapUrl(
  location?: JobSiteMapLocation | null,
  mapboxToken?: string | null,
  options?: {
    zoom?: number;
    dark?: boolean;
  },
): string | null {
  const normalizedLocation = normalizeJobSiteLocation(location);
  const token = mapboxToken === undefined || mapboxToken === null
    ? getMapboxToken().trim()
    : mapboxToken.trim();
  const zoom = Number.isFinite(options?.zoom) ? Number(options?.zoom) : MAPBOX_ZOOM;

  if (!normalizedLocation || !token) {
    return null;
  }

  const { lat, lng } = normalizedLocation;
  const style = options?.dark ? "dark-v11" : "light-v11";

  return `https://api.mapbox.com/styles/v1/mapbox/${style}/static/${lng},${lat},${zoom},${MAPBOX_BEARING}/${MAPBOX_IMAGE_SIZE}?access_token=${encodeURIComponent(token)}&attribution=false&logo=false`;
}
